import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import GradientButton from "../../component/GradientButton/GradientButton";
import TextInputOutline from "../../component/TextInputOutline/TextInputOutline";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import { isNetworkRequestFailedError } from "../../config/helpers";

class RegistrationToken extends Component {
  state = {
    isLoading: false,
    registeredUser: null,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;

    const registeredUser = localStorage.getItem("registeredUser");
    if (registeredUser) {
      this.setState({ registeredUser: JSON.parse(registeredUser) });
    } else {
      history.goBack();
    }

    setHistory(history);
  }

  changeHandler = (e) => {
    const name = e.target.name;

    this.setState({
      [name]: e.target.value,
      [name + "Error"]: "",
    });
  };

  submit = async (e) => {
    const { localHistory, setAlertMessage } = this.props;
    e.preventDefault();

    try {
      const { registrationToken, registeredUser } = this.state;

      if (!registrationToken) {
        throw new Error("Please enter registration token");
      }
      const payload = {
        pin: registeredUser.RSAPin,
        inputToken: registrationToken,
      };

      this.setState({ isLoading: true });

      await api.verifyActivationToken(payload);

      localStorage.removeItem("registeredUser");
      setAlertMessage({ type: "success", message: "Success" });
      localHistory.push("/login");
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.submit(e)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const {
      registrationToken,
      isLoading,
      registrationTokenError,
      registeredUser,
    } = this.state;

    if (!registeredUser) {
      return null;
    }

    return (
      <div className="login-main-container">
        <Container>
          <div className="login-container">
            <img
              alt="app-icon"
              src={require("../../assets/icons/app-icon.png")}
            />
            <p className="login-container-app-name">Premium Pension Limited</p>
            <p className="mt-4 text-center">
              Enter the token sent to your phone number{" "}
              <span className="font-weight-bold">{registeredUser.mobile}</span>{" "}
              and email{" "}
              <span className="font-weight-bold">{registeredUser.email}</span>
            </p>
            <form
              className="mb-5 mt-4 login-input-container align-items-start"
              onSubmit={this.submit}
            >
              <div className="my-2 w-100">
                <TextInputOutline
                  onChange={this.changeHandler}
                  value={registrationToken}
                  name="registrationToken"
                  label="Enter Activation Token"
                  errorMessage={registrationTokenError}
                />
              </div>
              <GradientButton
                type="submit"
                containerClasses="mt-4 mx-auto"
                label="Activate"
              />
              <div className="text-center w-100 mt-2">
                <Link className="back-to-login-text" to="/login">
                  Already a member? Login
                </Link>
              </div>
            </form>
          </div>
        </Container>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationToken);
